import { AspectRatio } from '@chakra-ui/react';
import Steps from '@components/interactive/Steps';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import badDocument from '@public/flaticons/bad-document.png';
import medicalFile from '@public/flaticons/medical-file.png';
import stress from '@public/flaticons/stress.png';
import telephone from '@public/flaticons/telephone.png';
import { TypeformLinks } from '@utils/index';
import { FsmColors } from 'chakra-ui/fsmTheme';
import Image, { StaticImageData } from 'next/image';
import { CtaTypes } from '../common/CTA';
import ProductHero from '../common/ProductHero';

const steps = [
  {
    header: 'Is your insurance refusing to pay a claim?',
    description: 'Is your insurance carrier refusing to pay a claim for a procedure or prescription that you need?',
    bg: FsmColors.teal,
    image: badDocument,
    alt: 'Insurance Graphic',
  },
  {
    header: "Can't get on the phone with a human?",
    description:
      'When you call your insurance carrier, are you able to get on the phone with a real human being who speaks your language?',
    bg: FsmColors.blue,
    image: telephone,
    alt: 'Phone Call Graphic',
  },
  {
    header: "We'll file a complaint for you.",
    description:
      "If you're having issues with your insurance carrierMap, we'll help you file a compaint with the Center of Medicare Services. It's free and .",
    bg: FsmColors.navy,
    image: medicalFile,
    alt: 'Complaint Graphic',
  },
];

const renderImage = (image: StaticImageData, alt: string) => (
  <AspectRatio ratio={1} width={['140px', '140px', '200px']}>
    <Image src={image} alt={alt} fill />
  </AspectRatio>
);

const CmsComplaint = () => {
  const typeformLink = TypeformLinks.cmsComplaint;
  const header = 'At wits end with your health insurance?';
  const subheader = `We'll submit a complaint with the Center of Medicare Services for you.`;
  const imageAlt = 'Stop Spam Hero';
  const buttonText = 'Get Started';

  return (
    <DefaultLayout>
      <ProductHero
        header={header}
        subheader={subheader}
        imageSrc={stress}
        imageAlt={imageAlt}
        ctaType={CtaTypes.button}
        buttonText={buttonText}
        href={typeformLink}
      />
      {steps && <Steps data={steps} renderImage={renderImage} />}
      <ProductHero
        header={header}
        subheader={subheader}
        ctaType={CtaTypes.button}
        buttonText={buttonText}
        href={typeformLink}
      />
    </DefaultLayout>
  );
};

export default CmsComplaint;
